let mobileSubNav = $(".nav__section__links");
const backBtn = $(".js-back");
const parentLink = $(".nav__section__title");
import CustomEvent from '../utils/events/customEvent';
import scrollLock from "../utils/scroll-lock";
import { breakpointQuery } from "../utils/breakpoints";

var isMobile =
  navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i) ||
  document.body.clientWidth <= 1024;


function init() {
    InitNav();
    InitNavSearch();
    InitNavReset();
}

// Opening the drawer hides main/footer and locks scrolling. Widening to the
// desktop layout with it open left the page blank, so close it there.
function InitNavReset() {
  breakpointQuery("lg").addEventListener("change", (e) => {
    if (!e.matches || !$(".js-nav").hasClass("open")) return;
    $(".js-menu-btn, .js-nav").removeClass("open");
    $("html").removeClass("nav-open");
    $(".nav__section__links").removeClass("active");
    scrollLock.disable();
    $("main, footer").show(0);
    $(".js-search-btn, .skip-to-main").show();
  });
}
function InitNav() {
  if (isMobile) {
    $(".nav__section__title").each((index, el) => {
      $(el).attr("tabindex", "-1");
    });
    $("#nav-search-mobile").attr("tabindex", "-1");
    $("#header-search-mobile .btn--search-alt").attr("tabindex", "-1");
  }

  $(".js-menu-btn").on("click", function () {
    $(".js-menu-btn, .js-nav").toggleClass("open");
    $("html").toggleClass("nav-open");
    let w = document.body.clientWidth;
    if ($("html").hasClass("nav-open") && w < 1024) {
      scrollLock.enable();
      $("#nav-search-mobile, .btn--search-alt").attr("tabindex", "0");
      $(".nav__section__title").attr("tabindex", 0);
      $("main, footer").hide(0);
      $(".js-search-btn").hide();
      $(".skip-to-main").hide();
    } else {
      if (w < 1024) {
        scrollLock.disable();
        $("#nav-search-mobile, .btn--search-alt").attr("tabindex", "-1");
        $("main, footer").show(0);
        $("header, .js-nav").scrollTop(0);
        $(".js-search-btn").show();
        $(".skip-to-main").show();
      }
    }
    if (!$(".js-menu-btn, .js-nav").hasClass("open")) {
      $("#nav-search-mobile, .btn--search-alt").attr("tabindex", "-1");
      $(".nav__section__links").removeClass("active");

      $("main, footer a").attr("aria-hidden", false);
      $("main, footer").show(0);

    }
  });

  $(".js-menu-btn").on("keypress", function (e) {
    $("#nav-search-mobile").attr("tabindex", "0");
    $(".nav__section__title").attr("tabindex", 0);
    $("#header-search-mobile .btn--search-alt").attr("tabindex", "0");

    if (e.code === "Enter") {
      $(".js-menu-btn, .js-nav").toggleClass("open");
      $("html").toggleClass("nav-open");
      let w = document.body.clientWidth;
      if ($("html").hasClass("nav-open") && w < 1024) {
        $("main, footer").hide(0);
        $(".js-search-btn").hide();
        $("#nav-search-mobile, .btn--search-alt").attr("tabindex", "0");
        scrollLock.enable();
      } else {
        if (w < 1024) {
          $(".js-search-btn").show();
          scrollLock.disable();
          $("#nav-search-mobile, .btn--search-alt").attr("tabindex", "-1");
          $("header, .js-nav").scrollTop(0);
        }
      }
      if (!$(".js-menu-btn, .js-nav").hasClass("open")) {
        $(".nav__section__links").removeClass("active");
        $("#nav-search-mobile, .btn--search-alt").attr("tabindex", "-1");
        $("main, footer").show(0);
        if (isMobile) {
          $(".nav__section__title").attr("tabindex", -1);
        }
      } else {
        $(".nav__section__subnav a").each((index, el) => {
          $(el).attr("tabindex", "-1");
        });
        $(".nav__section__title").attr("tabindex", 0);
      }
    }
  });
  backBtn.on("click", function () {
    $(this)
      .closest(".nav__section__links")
      .parent()
      .blur();
    $(this)
      .closest(".nav__section__links")
      .removeClass("active");
    $(".nav__section__subnav a").each((index, el) => {
      $(el).attr("tabindex", "-1");
    });
    $(".nav__section__title").attr('tabindex', 0);
    $("#nav-search-mobile").attr("tabindex", "0");
    $("#header-search-mobile .btn--search-alt").attr("tabindex", "0");
  });

document.addEventListener("keydown", function () {
    if (event.keyCode === 27) {
        $(".nav__section__links").addClass("active");
    }
});

if (isMobile) {
  $(".nav__section__subnav a").each((index, el) => {
    $(el).attr("tabindex", "-1");
  });
}

}

const openMobileSearch = () => {
  $(".js-menu-btn, .js-nav").addClass("open");
  $("html").toggleClass("nav-open");
  $(".nav__section__links").removeClass("active");
  $(".nav__section__subnav a").each((index, el) => {
    $(el).attr("tabindex", "-1");
  });
  $(".nav__section__title").attr("tabindex", 0);
  $("main, footer").hide(0);
  setTimeout(() => {
    const mobileSearch = document.getElementById("nav-search-mobile");
    $("#nav-search-mobile").attr("tabindex", "0");
    $(mobileSearch).focus();
  }, 250);
};


function InitNavSearch() {
  $(".js-search-btn").on("click", (event) => {
    event.preventDefault();
    $(".js-menu-btn, .js-nav").toggleClass("open");

    if (!$(".js-menu-btn, .js-nav").hasClass("open")) {
      $(".nav__section__links").removeClass("active");
      $(".nav__section__subnav a").each((index, el) => {
        $(el).attr("tabindex", "-1");
      });
    } else {
      setTimeout(() => {
        const mobileSearch = document.getElementById("nav-search-mobile");
        $("#nav-search-mobile").attr("tabindex", "0");
        $(mobileSearch).focus();
      }, 250);
    }
  });

  $(".header__search-mobile").on("click", (event) => {
    event.preventDefault();
    $(".js-search-btn").hide();
    openMobileSearch();
  });

  $(".header__search-mobile").on("keydown", (event) => {
    if (event.code === "Enter") {
      $(".js-search-btn").hide();
      openMobileSearch();
    }
  });

  $(".nav__section__title").on("click", function (event) {
    // Use $(this) rather than $(event.target) so that clicking a child element
    // (e.g. the <i> caret icon inside an NDS <button class="nav__section__title">)
    // still reads data-nav-name from the correct element.
    var $title = $(this);
    let secondNavItem = $title.data("nav-name");

    $(".nav__section__links[data-nav-name = " + secondNavItem + "]").addClass(
      "active"
    );

    if (secondNavItem) {
      $title.attr("aria-expanded", "true");
    }

    $("#nav-search-mobile").attr("tabindex", "-1");
    $("#header-search-mobile .btn--search-alt").attr("tabindex", "-1");
    const tabIndexes = $(
      ".nav__section__links[data-nav-name = " + secondNavItem + "]"
    ).find("a");
    $(tabIndexes).each((index, el) => {
      $(el).attr("tabindex", 0);
    });

    if (isMobile) {
      $(".nav__section__title").each((index, el) => {
        $(el).attr("tabindex", "-1");
      });
    }

    $($(tabIndexes).last()).on("keydown", (e) => {
      if (e.code === "Tab") {
        const menuButton = document.querySelector(".js-menu-btn");
        menuButton.focus();

      }
    });
    if (isMobile && !!secondNavItem) {
      event.preventDefault();
    }
    if ($title.hasClass("campaign")) {
      // event.preventDefault();
      setTimeout(() => {
        $(".js-menu-btn, .js-nav").removeClass("open");
      }, 1000);
    }
  });

  window.addEventListener('closeNav', (event) => {

    $(".js-menu-btn, .js-nav").removeClass("open");
    $("html").removeClass("nav-open");
    scrollLock.disable();
    if (window.innerWidth < 1024) {

      $("#nav-search-mobile, .btn--search-alt").attr("tabindex", "-1");
      $("main, footer").show(0);
      $("header, .js-nav").scrollTop(0);
      $(".js-search-btn").show();
    }
  })

  // Yext search support (Yext is being phased out; disabled per-site via the
  // Site_DisableYextFrontend KVC, in which case the search bar is never rendered)
  $(document).ready(function () {
    var $yextSearchBar = $('#yxt-SearchBar-input--search-bar');
    if (!$yextSearchBar.length) {
      return;
    }
    $yextSearchBar.attr('role', 'combobox');
    $yextSearchBar.attr('aria-activedescendant', '');
  });
}
export {
    init
}